import { render, staticRenderFns } from "./AddRemoveButton.vue?vue&type=template&id=48c33bf6"
import script from "./AddRemoveButton.vue?vue&type=script&lang=js"
export * from "./AddRemoveButton.vue?vue&type=script&lang=js"
import style0 from "./AddRemoveButton.vue?vue&type=style&index=0&id=48c33bf6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports